import {
  Transforms,
  Editor,
  Node,
  Text
} from 'slate';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import types from '../../elements/types';

import HelptapEditor from '../';

export function buildNode(options = {}) {

  return basicEditorValueSerializer.utilities.node.gallery.buildNode(options);

}

export function buildItemNode(options = {}) {

  return basicEditorValueSerializer.utilities.node.galleryItem.buildNode(options);

}

export function buildNodeFromRawFiles(rawFiles) {

  return basicEditorValueSerializer.utilities.node.gallery.buildNodeFromRawFiles(rawFiles);

}

export function insert(editor, rawFiles) {

  const node = buildNodeFromRawFiles(rawFiles);

  HelptapEditor.insertNode(editor, node);

}

export function getSettings(node) {

  return basicEditorValueSerializer.utilities.node.gallery.getSettings(node);

}

export function getContainerStyleObject(settings) {

  return basicEditorValueSerializer.utilities.node.gallery.getContainerStyleObject(settings);

}

export function updateSettings(editor, galleryPath, settings) {

  const galleryNode = Editor.node(editor, galleryPath)[0];

  HelptapEditor.setAttributes(editor, {
    properties: {
      ...(galleryNode.properties || {}),
      ...settings
    }
  }, galleryPath);

}

export function appendItems(editor, galleryPath, galleryId, rawFiles) {

  const galleryNode = Editor.node(editor, galleryPath)[0];
  const galleryProperties = galleryNode.properties || {};
  const itemStyles = galleryProperties.galleryItemStyles || {};
  const insertIndex = galleryNode.children.length;

  Editor.withoutNormalizing(editor, function insertItems() {

    rawFiles.forEach(function insertItem(rawFile, offset) {

      const item = buildItemNode({ rawFile, galleryId, styles: itemStyles });

      Transforms.insertNodes(editor, item, { at: [...galleryPath, insertIndex + offset] });

    });

  });

}

export function extractItemStyles(itemNode) {

  return basicEditorValueSerializer.utilities.node.galleryItem.extractStyles(itemNode);

}

export function removeEmptyGallery(editor, galleryPath) {

  const children = Array.from(Node.children(editor, galleryPath));

  for (const [childNode] of children) {

    if (childNode.type === types.GALLERY_ITEM) {
      return false;
    }

  }

  Transforms.removeNodes(editor, { at: galleryPath });

  return true;

}

export function normalizeGalleryChildren(editor, galleryPath) {

  const children = Array.from(Node.children(editor, galleryPath));

  let galleryItemCount = 0;

  for (const [childNode] of children) {

    if (childNode.type === types.GALLERY_ITEM) {
      galleryItemCount++;
    }

  }

  for (const [childNode, childPath] of children) {

    if (childNode.type === types.GALLERY_ITEM) {
      continue;
    }

    if (Text.isText(childNode) === true && galleryItemCount === 0) {
      continue;
    }

    Transforms.removeNodes(editor, { at: childPath });

    return true;

  }

  return false;

}

export function syncItemStyles(editor, galleryNode, galleryPath, itemNode) {

  const itemStyles = extractItemStyles(itemNode);
  const galleryProperties = galleryNode.properties || {};
  const currentStyles = galleryProperties.galleryItemStyles || {};

  if (JSON.stringify(itemStyles) === JSON.stringify(currentStyles)) {
    return false;
  }

  Editor.withoutNormalizing(editor, function applyItemStyles() {

    HelptapEditor.setAttributes(editor, {
      properties: {
        ...galleryProperties,
        galleryItemStyles: itemStyles
      }
    }, galleryPath);

    for (const [, childPath] of Node.children(editor, galleryPath)) {
      HelptapEditor.setAttributes(editor, itemStyles, childPath);
    }

  });

  return true;

}